// extracted by mini-css-extract-plugin
export var avatar = "_n1-3";
export var avatarContainer = "_n1-2";
export var avatarSpacer = "_n1-5";
export var avatarSpacerContainer = "_n1-4";
export var avatarStackContainer = "_n1-1";
export var bubble = "_n1-0";
export var remainderBubble = "_n1-6";